import { CLEAR_ALL, FILTERS_CHANGE, FILTERS_TOGGLE } from 'constants/ActionTypes';

const initialState = {};
const initialSectionState = {
    filters: {},
    show: false,
};

export default function (state = initialState, action) {
    switch (action.type) {
        case FILTERS_CHANGE: {
            const sectionState = state[action.payload.section] || { ...initialSectionState };
            return {
                ...state,
                [action.payload.section]: {
                    ...sectionState,
                    filters: action.payload.filters,
                },
            };
        }
        case FILTERS_TOGGLE: {
            const sectionState = state[action.payload.section] || { ...initialSectionState };
            return {
                ...state,
                [action.payload.section]: {
                    ...sectionState,
                    show: !sectionState.show,
                },
            };
        }
        case CLEAR_ALL:
            return initialState;
        default:
            return {
                ...state,
            };
    }
}
